import axios from 'axios';

export default function (context, val) {
    let id = val.RegularPaymentId ? val.RegularPaymentId : val.Id;
    window.app.$confirm('Вы действительно хотите удалить требование?', 'Удаление требования №' + id, {
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отмена',
        type: 'info'
    }).then(() => {
        context.commit('list/remove', val);
        axios({
            method: 'post',
            url: '/tourclient/payment/deleteRegular',
            data: 'id=' + id,
            requestId: 'tourclient/payment/deleteRegular',
        }).then(r => {
            if(val.cb)val.cb();
            window.app.$message({
                type: 'success',
                message: 'Требование удалено'
            });
        }).catch(e => {
            context.dispatch('error', e, {root: true});
        });
    })
}